<template>
  <div class="sub-container">
    <header>
      <h4 @click="onBack">&lt; {{$t('poptop.back')}}</h4>
      <h2>{{$t('poptop.title')}}</h2>
    </header>
    <div class="choose-period">
      <h3>{{$t('poptop.sum')}}</h3>
      <div
        class="period-box mt-0"
        :class="{
            'active': amount == 300 && !custom_amount
          }"
        @click="selectAmount(300)"
      >
        <p>{{$t('poptop.hint')}}</p>
      </div>
      <div
        class="period-box d-flex justify-content-between"
        :class="{
            'active': amount == 500 && !custom_amount
          }"
        @click="selectAmount(500)"
      >
        <p>{{$t('poptop.hintb')}}</p>
      </div>
      <div class="period-box p-0">
        <input :placeholder="$t('poptop.input')" v-model.number="custom_amount" />
      </div>
      <form
        method="POST"
        action="https://www.liqpay.ua/api/3/checkout"
        accept-charset="utf-8"
        target="_blank"
      >
        <input type="hidden" name="data" :value="form.data" />
        <input type="hidden" name="signature" :value="form.signature" />
        <button class="pay" :disabled="generating_form">{{$t('poptop.pay')}} ({{target_amount}} грн.)</button>
      </form>
      <img src="../../assets/liqpay.png" alt />
    </div>
    <div class="payment-block">
      <img src="/icons/visa-card.svg" class="take2pay" />
      <img src="/icons/ms-card.svg" class="take2pay" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import BillingAPI from "@/api/billing";

import BillingHistoryModal from "@/components/modals/BillingHistoryModal.vue";
import SubscriptionBadge from "@/components/subscriptions/SubscriptionBadge.vue";

export default {
  props: {
    isCompact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      billsHistory: false,
      deposit_modal: false,
      form: {},
      amount: 300,
      custom_amount: null,
      generating_form: false,

      last_transactions: []
    };
  },
  watch: {
    amount() {
      this.generateForm();
    },
    custom_amount() {
      this.generateForm();
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    billing_account() {
      return this.$store.state.billing_account;
    },
    target_amount() {
      return this.custom_amount || this.amount;
    }
  },
  methods: {
    generateForm() {
      this.generating_form = true;

      if (this.target_amount < 300) return;

      BillingAPI.getDepositForm(this.target_amount, this.cafe.name)
        .then(data => {
          this.form = data.form;
          this.generating_form = false;
        })
        .catch(error => {
          this.$store.dispatch("showError", "subscription_form_failed");
        });
    },
    selectAmount(amount) {
      this.amount = amount;
      this.custom_amount = null;
    },
    onBack() {
        this.$emit('close');
    }
  },
  mounted() {
    this.generateForm();
  }
};
</script>

<style scoped>
 

.sub-container {
  height: 100vh;
  width: 100%;
  background: black;
  position: fixed;
  top: 0;
  z-index: 15;
  left: 0;
  right: 0;
}

.take2pay {
  height: 4vh;
  margin-top: 1.7vh;
  width: 8vh;
}

h2 {
  font-size: 6vh;
  padding: 0;
  display: block;
  min-width: 16vh;
}

h3 {
  font-size: 2.7vh;
}

h5.title {
  margin-bottom: 2.2vh;
  font-size: 2vh;
}

.general-wrapper {
  display: flex;
  padding-top: 2.2vh;
  justify-content: space-between;
  width: 100%;
}

.pl-25 {
  padding-left: 2.8vh;
  display: grid;
}

p {
  margin-bottom: 0;
}

.subscription-tarrifs {
  margin-top: 1.2vh;
  display: block;
}

.choose-period img {
  height: 2vh;
  width: auto;
  display: block;
  margin: 2vh auto 0;
}

.period-box input {
  width: 100%;
  background: transparent;
  color: #ededed;
  outline: none;
  padding: 1.8vh 2vh;
  border: none;
}

.choose-period {
  width: 45vh;
  position: absolute;
  left: 0;
  right: 0;
  padding: 5vh;
  top: 50%;
  transform: translateY(-50%);
  border: 1px solid #464646;
  margin: 0 auto;
  color: #ededed;
}

.choose-period h3 {
  font-size: 2.8vh;
  line-height: 0.8;
  padding: 0 0 2.2vh;
}

.period-box {
  border-radius: 1vh;
  border: 1px solid #1d1d1b;
  padding: 1.8vh 2vh;
  margin-top: 1.1vh;
  font-size: 2vh;
}

.period-box img {
  height: 3vh;
  width: auto;
  align-self: center;
}
.period-box.active {
  background: #1d1d1b;
  border: 2px solid #129b81;
}
header {
  padding: 6vh 0 0 0;
  width: 118vh;
  margin: 0 auto;
  color: #ededed;
}

header h2 {
  padding: 1vh 0 0 0;
  font-size: 4vh;
}

header h4 {
    cursor: pointer;
}

button.pay {
  background: #11d180;
  width: 100%;
  border: none;
  color: #ededed;
  border-radius: 1vh;
  margin-top: 2vh;
  font-size: 2vh;
  padding: 1.3vh 1vh;
  cursor: pointer;
}

button.pay:disabled {
  opacity: 0.7;
}

.payment-block {
  position: absolute;
  bottom: 18vh;
  left: 0;
  right: 0;
  text-align: center;
}
</style>